import React, { useRef } from "react";
import { Box, Typography, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, IconButton, Tooltip, Chip } from "@mui/material";
import MoreHorizSharpIcon from "@mui/icons-material/MoreHorizSharp";
import { Menu as PrimeMenu } from "primereact/menu";

export function LandingPageAdsTable({ items = [], onEdit, onDelete }) {
  const menuRefs = useRef([]);

  const getContentTypeColor = (contentType) => {
    switch (contentType) {
      case 'video':
        return 'primary';
      case 'image':
        return 'success';
      case 'gif':
        return 'warning';
      case 'svg':
        return 'info';
      case 'text':
        return 'secondary';
      default:
        return 'default';
    }
  };

  return (
    <Box>
      <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px", mb: 1 }}>
        Landing Page Ads
      </Typography>
      <TableContainer sx={{ height: "100%" }}>
        <Table stickyHeader aria-label="sticky table" sx={{ minWidth: 650 }}>
          <TableHead style={{ backgroundColor: "background.upload" }}>
            <TableRow>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">S No</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Name</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Content Type</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Heading</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Colors</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Status</TableCell>
              <TableCell sx={{ fontWeight: "600", textAlign: "left", backgroundColor: "background.upload" }} align="left">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {items?.length > 0 ? (
              items.map((item, index) => {
                menuRefs.current[index] = menuRefs.current[index] || React.createRef();
                
                return (
                  <TableRow key={item.id}>
                    <TableCell sx={{ textAlign: "left", backgroundColor: "white" }}>{index + 1}</TableCell>
                    <TableCell sx={{ textAlign: "left", backgroundColor: "white" }}>
                      <Typography sx={{ fontSize: "14px", fontWeight: "500", lineHeight: "22px" }}>
                        {item.name || '-'}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ textAlign: "left", backgroundColor: "white" }}>
                      <Chip 
                        label={item.content_type?.toUpperCase() || 'N/A'} 
                        color={getContentTypeColor(item.content_type)}
                        size="small"
                        sx={{ textTransform: 'uppercase', fontWeight: '600' }}
                      />
                    </TableCell>
                    <TableCell sx={{ textAlign: "left", backgroundColor: "white" }}>
                      <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px", maxWidth: "200px", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                        {item.heading || '-'}
                      </Typography>
                    </TableCell>
                    <TableCell sx={{ textAlign: "left", backgroundColor: "white" }}>
                      <Box sx={{ display: "flex", gap: 1, alignItems: "center", flexWrap: "wrap" }}>
                        {item.background_color && (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Box 
                              sx={{ 
                                width: 12, 
                                height: 12, 
                                backgroundColor: item.background_color, 
                                border: "1px solid #ccc", 
                                borderRadius: "2px" 
                              }} 
                            />
                            <Typography sx={{ fontSize: "10px", color: "text.secondary" }}>
                              BG
                            </Typography>
                          </Box>
                        )}
                        {item.text_color && (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Box 
                              sx={{ 
                                width: 12, 
                                height: 12, 
                                backgroundColor: item.text_color, 
                                border: "1px solid #ccc", 
                                borderRadius: "2px" 
                              }} 
                            />
                            <Typography sx={{ fontSize: "10px", color: "text.secondary" }}>
                              TXT
                            </Typography>
                          </Box>
                        )}
                        {item.border_color && (
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <Box 
                              sx={{ 
                                width: 12, 
                                height: 12, 
                                backgroundColor: item.border_color, 
                                border: "1px solid #ccc", 
                                borderRadius: "2px" 
                              }} 
                            />
                            <Typography sx={{ fontSize: "10px", color: "text.secondary" }}>
                              BRD
                            </Typography>
                          </Box>
                        )}
                      </Box>
                    </TableCell>
                    <TableCell sx={{ textAlign: "left", backgroundColor: "white" }}>
                      {item.is_active === false ? (
                        <Box sx={{ width: "120px", height: "22px", backgroundColor: "button.backgroundDelete", border: "1px solid", borderColor: "borders.red", borderRadius: "2px", padding: "1px 8px", display: "flex", justifyContent: "center" }}>
                          <Typography sx={{ fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.red", textAlign: "center", textTransform: "uppercase", width: "88px" }}> Inactive</Typography>
                        </Box>
                      ) : (
                        <Box sx={{ width: "67px", height: "22px", backgroundColor: "button.backgroundEdit", border: "1px solid", borderColor: "borders.green", borderRadius: "2px", padding: "1px 8px", display: "flex", justifyContent: "center" }} >
                          <Typography sx={{ textAlign: "center", fontSize: "12px", fontWeight: 400, lineHeight: "20px", color: "borders.green", textTransform: "uppercase", width: "67px" }}>Active</Typography>
                        </Box>
                      )}
                    </TableCell>
                    <TableCell sx={{ textAlign: "left", backgroundColor: "white" }}>
                      <PrimeMenu
                        model={[
                          { label: "Edit", command: () => onEdit && onEdit(item) },
                          { label: "Delete", command: () => onDelete && onDelete(item) },
                        ]}
                        popup
                        ref={menuRefs.current[index]}
                        style={{ marginTop: "-10px" }}
                        className="custom-menu"
                      />
                      <Tooltip title="Actions" arrow>
                        <IconButton
                          sx={{ textTransform: "none" }}
                          onClick={(event) =>
                            menuRefs.current[index]?.current?.toggle(event)
                          }
                        >
                          <MoreHorizSharpIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                );
              })
            ) : (
              <TableRow>
                <TableCell colSpan={7} sx={{ textAlign: "center", height: "200px" }}>
                  No Landing Page Ads Found
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
